import { render, staticRenderFns } from "./JurisdictionList.vue?vue&type=template&id=434aeea9&scoped=true&"
import script from "./JurisdictionList.vue?vue&type=script&lang=js&"
export * from "./JurisdictionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434aeea9",
  null
  
)

export default component.exports